import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import styles from './PrdPreviewPage.module.css';
import { generatePrd, prdToMarkdown } from '../lib/prdGenerator';
import { selectQuestions } from '../mocks/questions';
import { threadHistory } from '../mocks/thread';
import { summarizeThread } from '../lib/summarizer';

const STORAGE_KEY = 'prd-bot-markdown';

function getInitialMarkdown(): string {
  const stored = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  if (stored) return stored;

  const summary = summarizeThread(threadHistory.map((m) => m.text).join(' '));
  const questions = selectQuestions(threadHistory.map((m) => m.text).join(' '));
  const userAnswers: Record<string, string> = {};
  questions.forEach((q) => {
    userAnswers[q.id] = q.defaultAnswer;
  });
  return prdToMarkdown(generatePrd(summary, questions, userAnswers));
}

export default function PrdPreviewPage() {
  const markdown = useMemo(() => getInitialMarkdown(), []);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <Link to="/" className={styles.back}>← Back to thread</Link>
        <header className={styles.header}>
          <h1>prd.md</h1>
          <div className={styles.meta}>Generated by @prd-bot from the thread discussion.</div>
        </header>
        <div className={styles.preview} data-testid="prd-preview">
          <ReactMarkdown>{markdown}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}
